
import { useNavigate } from 'react-router-dom';
import * as yup from 'yup';
import useAddFormData from '../../../../Components/Hooks/useAddFormData';
import { useToast } from '../../../../Components/Others/ToastServices';
import { useMemo, useState } from 'react';
import UseCustomerDropDownNew from '../../../../Components/Hooks/useCustomerSearch';
import UseDropDown from '../../../../Components/Hooks/useDropDown';
import useFetchMataData from '../../../../Components/Hooks/useFetchMataData';
import { useFormik } from 'formik';

import { BackButton, CancelButton, SubmitButton } from '../../../../Components/Utils/Buttons';
import DropDownAddMetaData from '../../../../Components/Utils/selectAddMetaData';
import FormikSelectTwo from '../../../../Components/Utils/Select';
import { NuDate, NuInput, NuTextArea, NuTime,   } from '../../../../Components/Utils/Input';
import MultiSelect from '../../../../Components/Utils/MultiSelect';

import Attachement from '../../../../Components/Utils/CustomAttrachmentupload';
import Breadcrumb from '../../../../Components/Utils/Breadcrumb';

const filetype = [
  "docx",
  "doc",
  "xlsx",
  "xls",
  "pdf",
  "txt",
  "pptx",
  "mp4",
  "mov",
  "wmv",
  "avi",
  "flv",
  "mkv",
];

function CreateTask() {
  const navigate = useNavigate();
  const {  addFormData } = useAddFormData();
   const toast = useToast();
    const [image, setImage] = useState([]);
   const [selectedFile, setSelectedFile] = useState(null);
      const [searchClient, setSearchClient] = useState("");
   
  const { data: client, setDataCustomer } = UseCustomerDropDownNew(
     "/clients/drop-down",
     searchClient
   );
   const { data: user } = UseDropDown(`/user/new-drop-down`);
   const { value: Priority,getData:refPriority } = useFetchMataData(
    `/dropdown/dropdown-details/`,
    "priority"
  ); 
 

  
   const { value: Status, getData: refStatus } = useFetchMataData(
    `/dropdown/dropdown-details/`,
    "Status_Schedules"
  );
  const { value: Type, getData: refType } = useFetchMataData(
       `/dropdown/dropdown-details/`,
       "Type_Schedules"
     );
     const [createNew, setCreateNew] = useState({
   
      taskName:"",
      taskDesc:"",
      assignedTo:"",
      copyTo:"",
      priority:"",
      startDate:"",
      endDate:"",
      completeDate:"",
      noOfDays:"",
      noOfWeeks:"",
      reminderDate:"",
      reminderTime:"",
      attachments: [],
      

  });

    function handleImageChange(e) {
    const maxFileSize = 200000000; // 200 MB
    const files = Array.from(e.target.files);
    let fileArr = [];

    files.forEach((item) => {
      if (item.size < maxFileSize) {  
        fileArr.push(item);
      } else {
        toast.open({
          type: "warning",
          message: `File Size too big`,
          description: `${item.name} is removed and not uploaded`,
        });
      }
    });

    setSelectedFile(fileArr);


    setImage(fileArr);
    e.target.value = null;
  }

  const removeImages = (value) => {
    let List = selectedFile.filter((item) => item?.name !== value?.name);
    setSelectedFile([...List]);
    setImage(List);
  };

  const formik = useFormik({
      enableReinitialize: true,
      initialValues: createNew,
      validateOnChange: false,
      validateOnBlur: false,
      validationSchema: yup.object({
        // clientId: yup.string().required("Client is required!"),
        // projectName: yup.string().required("Project Name is required!"),
        
        
       // phone: yup
       //    .string()
       //    .matches(/^\d+$/, "Phone number must contain only digits")
       //    .min(9, "Phone number must be at least 9 digits")
       //    .max(11, "Phone number must be at most 11 digits")
       //    .required("Phone number is required"),
       //    cPMobile: yup
       //    .string()
       //    .matches(/^\d+$/, "Phone number must contain only digits")
       //    .min(9, "Phone number must be at least 9 digits")
       //    .max(11, "Phone number must be at most 11 digits")
       //    .required("Phone number is required"),
       //  email: yup.string().required("Email is required!"),
       //  companyName: yup.string().required("Company Name is required!"),
       //  // website: yup.string().required("Website is required!"),
       //  cpName: yup.string().required("Contact Person is required!"),
      }),
      onSubmit: async (value, { resetForm }) => {
        const { startDate, endDate } = value;
      
        if (!startDate || !endDate) {
          toast.open({ type: "warning", message: "Start Date and End Date are required." });
          return;
        }
      
        const start = new Date(startDate);
        const end = new Date(endDate);
      
        if (end <= start) {
          toast.open({ type: "error", message: "End Date must be after Start Date." });
          return;
        }
      
        // Prepare and submit formData as you already do
        let formData = new FormData();
        const valueWithProducts = { ...value };
        formData.append("taskData", JSON.stringify(valueWithProducts));
      
        if (selectedFile !== null) {
          selectedFile.forEach((file) => {
            formData.append("attachments", file);
          });
        } else {
          formData.append("attachments", []);
        }
            await addFormData({url:`/tasks/new-task`, formData:formData,navigateUrl:`/tasks/my-tasks`,resetForm:resetForm   });
      
        // addFormData("/tasks/new-task", formData, resetForm);
      }
    });
 
    function diff_weeks(dt2, dt1) {
      var diff = (dt2.getTime() - dt1.getTime()) / 1000;
      diff /= 60 * 60 * 24 * 7;
      //  let result = Math.abs(Math.round(diff));
      return Math.abs(Math.round(diff));
    }
  
    function DateDiff(createDate, expiryDate) {
      let timeDiff = Math.abs(expiryDate.getTime() - createDate.getTime());
      let diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));
      return diffDays == 0 ? diffDays + 1 : diffDays + 1;
    }
  
    useMemo(() => {
      if (formik.values.startDate && formik.values.endDate) {
        const startDate = new Date(formik.values.startDate);
        const endDate = new Date(formik.values.endDate);
    
        if (endDate > startDate) {
          const diffDays = Math.ceil(Math.abs(endDate - startDate) / (1000 * 60 * 60 * 24));
          const diffWeeks = Math.ceil(diffDays / 7);
    
          formik.setFieldValue("noOfDays", diffDays);
          formik.setFieldValue("noOfWeeks", diffWeeks);
        } else {
          formik.setFieldValue("noOfDays", 0);
          formik.setFieldValue("noOfWeeks", 0);
        }
      }
    }, [formik.values.startDate, formik.values.endDate]);

  return (
    <div className=" w-full h-full py-2 px-4 ">
         <div className="flex justify-between w-full"> 
         <Breadcrumb
                  items={[
                      {   name: "My Task" ,
                      link:"/tasks/my-tasks"
                    },
                    { name: "Create" },
                  ]}
                />     
        <BackButton />
      </div>
      <form onSubmit={formik.handleSubmit}>
        <div className="w-full mx-auto h-[calc(100vh-145px)] bg-white rounded-xl overflow-hidden mt-4">
          <div className=" w-full h-full flex justify-start content-start flex-wrap py-2 px-4  overflow-y-auto">
            <div className="w-full">
              <p className="pb-2 pt-4 px-4 text-sm font-medium text-[#111537] underline decoration-textColor-main decoration-2 underline-offset-4">
                Task 
              </p>
            </div>
            <NuInput
              label="Task"
              type="text"
              formik={formik}
              placeholder="Task"
              name="taskName"
              width="w-full md:w-1/3 md:-mt-2"
              displayProperty={"Type"}
              propertyName={"Type_Schedules"}
                 getFunc={refType}
              isRequired={true}

            />
            {/* <NuInput
              label="Task Description"
              type="text"
              formik={formik}
              placeholder="Task Description"
              name="taskDesc"
              width="w-full md:w-[66%] md:-mt-2"
              displayProperty={"Type"}
              propertyName={"Type_Schedules"}
                 getFunc={refType}
              isRequired={true}

            /> */}
            <MultiSelect
              label="Assigned To"
              Options={user}
              formik={formik}
              placeholder="Choose"
              name="assignedTo"

              width="w-full md:w-1/3 md:-mt-2"
            />
             <MultiSelect
              label="Copy To"
              Options={user}
              formik={formik}
              placeholder="Choose"
              name="copyTo"

              width="w-full md:w-1/3 md:-mt-2"
            />

            <FormikSelectTwo
              label="Priority"
              Options={Priority}
              formik={formik}
              placeholder="Choose"
              name="priority"
              // isRequired={true}

              width="w-full md:w-1/3 md:-mt-2"
            />
              <NuDate
              label="Start Date"
              placeholder="Start Date"
              formik={formik}
              name="startDate"
              isRequired={true}
              width="w-full md:w-1/3 md:-mt-2"
              
            />
             <NuDate
              label="End Date"
              placeholder="End Date"
              formik={formik}
              name="endDate"
              isRequired={true}
              width="w-full md:w-1/3 md:-mt-2"
              
            />
             <NuDate
              label="Completion Date"
              placeholder="Completion Date"
              formik={formik}
              name="completeDate"
             
              width="w-full md:w-1/3 md:-mt-2"
            />

             <NuInput
              label="Number Of Days"
             type="number"
              formik={formik}
              placeholder="0"
                disabled={true}
              name="noOfDays"
              // isRequired={true}
              width="w-full md:w-1/3 md:-mt-2"
            />
            <NuInput
              label="Number Of Weeks"
             type="number"
              formik={formik}
              placeholder="0"
              disabled={true}
              name="noOfWeeks"
              // isRequired={true}
              width="w-full md:w-1/3 md:-mt-2"
            />
            <NuDate
              label="Reminder Date"
              placeholder="Date"
              formik={formik}
              name="reminderDate"
             
              width="w-full md:w-1/3 md:-mt-2"
            />
              <NuTime
              label="Reminder Time"
              placeholder="Date"
              formik={formik}
              name="reminderTime"
             
              width="w-full md:w-1/3 md:-mt-2"
            />
<NuTextArea
              type="text"
              label="Scope of Work"
              placeholder="Scope of Work"
              formik={formik}
              name="scopeOfWork"
              // new_width='w-full md:w-1/2'
              width="w-full md:w-1/3 md:-mt-2"
            />

         <Attachement
                handleChange={handleImageChange}
                preview={image || ""}
                width="w-full"
                label="Attach" 
                multiple={true}
                removeImages={removeImages}
              />
           <div className="w-full  my-4 mt-8 ">
              <div className=" flex justify-end gap-4">
                 <CancelButton
                  handleClick={() => {
                    navigate(-1);
                  }}
                />
                <SubmitButton />
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  );
}

export default CreateTask
